var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHalfFilled = function SvgHalfFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3E6245",
    fillRule: "evenodd",
    d: "M12 2.25c.966 0 1.75.784 1.75 1.75v6.25H20a1.75 1.75 0 1 1 0 3.5h-6.25V20a1.75 1.75 0 1 1-3.5 0v-6.25H4a1.75 1.75 0 1 1 0-3.5h6.25V4c0-.966.784-1.75 1.75-1.75",
    clipRule: "evenodd"
  })));
};
export default SvgHalfFilled;